(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup-modal"] && !Shopify.designMode) return;
  try {
    
  const modal = document.getElementById('popup-modal');
  const openBtn = document.getElementById('openModal');
  const closeBtn = document.getElementById('closeModal');
  console.log(modal, 'modal');
  console.log(openBtn, 'open');
  console.log(closeBtn, 'close');
  
  console.log();

  // Open modal
  openBtn.addEventListener('click', () => {
    modal.style.display = 'flex';
    console.log('modal open');
  });

  // Close modal via X button
  closeBtn.addEventListener('click', () => {
    modal.style.display = 'none';
    console.log('modal close');
  });

  // Close modal by clicking outside content
  window.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
      console.log('modal close');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
